module.exports = __webpack_public_path__ + "static/img/s03@2x.22a2f72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/s03@2x.png
// module id = a6bO
// module chunks = 1